import React from 'react';
import { Box, Icons, Typography, useTheme } from '@ublend-npm/aulaui-core';
import { createStyles } from './CommonRoomResponsive.styles';

const CommonRoomFeedResponsive = () => {
  const theme = useTheme();
  const styles = createStyles(theme);

  return (
    <Box sx={styles.feedLayout} data-testid="responsive-feed-layout">
      <Box
        component="section"
        aria-label="Post composer"
        sx={styles.composerRegion}
      >
        <Box sx={styles.placeholderHeader}>
          <Box sx={styles.placeholderIcon} aria-hidden="true">
            <Icons.EditOutlined fontSize="small" />
          </Box>
          <Box sx={styles.placeholderText}>
            <Typography component="h2" variant="subtitle1">
              Create a post
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Share something with your space…
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box
        component="section"
        aria-label="Feed controls"
        sx={styles.feedControlsRegion}
      >
        <Box sx={styles.feedTabs}>
          <Typography sx={styles.activeFeedTab}>Feed</Typography>
          <Typography color="text.secondary">Pinned</Typography>
        </Box>
        <Typography color="text.secondary">Filter</Typography>
      </Box>

      <Box
        component="section"
        aria-label="Common Room feed"
        sx={styles.postsRegion}
      >
        <Box sx={styles.postPlaceholderCard}>
          <Box sx={styles.placeholderHeader}>
            <Box sx={styles.placeholderIcon} aria-hidden="true">
              <Icons.Person fontSize="small" />
            </Box>
            <Box sx={styles.placeholderText}>
              <Typography component="h2" variant="subtitle1">
                Post author
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Post date and time
              </Typography>
            </Box>
          </Box>

          <Typography variant="body2">
            Common Room post content will render in this region.
          </Typography>

          <Box sx={styles.placeholderFooter}>
            <Typography variant="caption" color="text.secondary">
              Reactions
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Comments
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CommonRoomFeedResponsive;
